import isNil from 'lodash-es/isNil';
import { useClient, useQuery } from '..';
const EMPTY_REPORTS = [];
function useIrrigationReports({ end, start, plotId, enabled = true, includeDripIrrigationReport = false }) {
    const client = useClient();
    const request = useQuery(client.measurementsReports.getAllPages({
        metrics: includeDripIrrigationReport ? ['IRR', 'DI'] : ['IRR'],
        before: !isNil(end) ? `${end}` : undefined,
        since: !isNil(start) ? `${start}` : undefined,
        plotId
    }), { enabled });
    const data = request.data ?? EMPTY_REPORTS;
    return { request, data };
}
export default useIrrigationReports;
